<template>
    <div>
        <transition name="commonpage">
            <router-view />
        </transition>
    </div>
</template>

<script>
export default {
    name: "OrganizationManagement"
}
</script>

<style lang="scss" scoped>
    
</style>